// Typelizer digest b913481fd4f5ca536c42dc7827246bd8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /account_selection */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account_selection', {}, options),
    method: 'post',
  }),
}
